import { useState, useRef, useEffect } from "react";
import BudmenLogo from '../shared/BudmenLogo';

// ═══════════════════════════════════════════════════════════════════
// PASSWORD GATE COMPONENT
// ═══════════════════════════════════════════════════════════════════

export function PasswordGate({ onUnlock, password, reportName }) {
  const [passwordInput, setPasswordInput] = useState("");
  const [error, setError] = useState(false);
  const [shake, setShake] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleSubmit = () => {
    if (passwordInput.trim().toLowerCase() === password.toLowerCase()) {
      onUnlock();
    } else {
      setError(true);
      setShake(true);
      setTimeout(() => setShake(false), 500);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg,var(--navy) 0%,#243B63 50%,var(--teal) 100%)",
        padding: 24,
      }}
    >
      <div
        style={{
          animation: shake ? "shake .4s ease" : "scaleIn .6s ease forwards",
          maxWidth: 420,
          width: "100%",
          textAlign: "center",
        }}
      >
        <BudmenLogo fill="white" height="40" className="mx-auto mb-10" />
        <h1
          style={{
            fontFamily: "var(--serif)",
            color: "white",
            fontSize: "clamp(28px,5vw,40px)",
            lineHeight: 1.2,
            marginBottom: 12,
          }}
        >
          Program Report
        </h1>
        {reportName && (
          <p
            style={{
              color: "var(--gold)",
              fontSize: 18,
              fontFamily: "var(--serif)",
              fontStyle: "italic",
              marginBottom: 20,
            }}
          >
            {reportName}
          </p>
        )}
        <p
          style={{
            color: "rgba(255,255,255,.6)",
            fontSize: 15,
            fontFamily: "var(--sans)",
            marginBottom: 40,
          }}
        >
          Enter the access code shared with you.
        </p>
        <input
          ref={inputRef}
          type="password"
          value={passwordInput}
          onChange={(e) => {
            setPasswordInput(e.target.value);
            setError(false);
          }}
          onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
          placeholder="Access code"
          style={{
            width: "100%",
            padding: "16px 20px",
            fontSize: 16,
            fontFamily: "var(--mono)",
            letterSpacing: ".1em",
            border: error
              ? "2px solid var(--rust)"
              : "2px solid rgba(255,255,255,.15)",
            borderRadius: 8,
            background: "rgba(255,255,255,.08)",
            color: "white",
            outline: "none",
            transition: "border-color .3s",
          }}
        />
        {error && (
          <p
            style={{
              color: "var(--gold)",
              fontSize: 13,
              marginTop: 12,
              fontFamily: "var(--sans)",
            }}
          >
            That code didn't work. Try again?
          </p>
        )}
        <button
          onClick={handleSubmit}
          style={{
            width: "100%",
            marginTop: 16,
            padding: "14px",
            fontSize: 15,
            fontWeight: 600,
            fontFamily: "var(--sans)",
            background: "var(--orange)",
            color: "var(--navy)",
            border: "none",
            borderRadius: 8,
            cursor: "pointer",
            transition: "opacity 0.2s",
          }}
          onMouseOver={(e) => (e.target.style.opacity = "0.9")}
          onMouseOut={(e) => (e.target.style.opacity = "1")}
        >
          View Report →
        </button>
        <p
          style={{
            color: "rgba(255,255,255,.3)",
            fontSize: 12,
            marginTop: 32,
            fontFamily: "var(--sans)",
          }}
        >
          Prepared by Budmen Industries · budmen.com
        </p>
      </div>
    </div>
  );
}